import { createSelector } from 'reselect';

const selectDbaAgentDBNAgentMappings = (state: any) => state.dbaAgentDBNAgentMappings;


export const selectDbaAgentDBNAgentMappingsCurrentItem = createSelector([selectDbaAgentDBNAgentMappings], (dbaAgentDBNAgentMappings) => dbaAgentDBNAgentMappings.current);

export const selectDbaAgentDBNAgentMappingsListItems = createSelector([selectDbaAgentDBNAgentMappings], (dbaAgentDBNAgentMappings) => dbaAgentDBNAgentMappings.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDbaAgentDBNAgentMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbaAgentDBNAgentMappingsQueryItems = createSelector([selectDbaAgentDBNAgentMappings], (dbaAgentDBNAgentMappings) => dbaAgentDBNAgentMappings.query);

export const selectDbaAgentDBNAgentMappingsCreatedItem = createSelector([selectDbaAgentDBNAgentMappings], (dbaAgentDBNAgentMappings) => dbaAgentDBNAgentMappings.create);

export const selectDbaAgentDBNAgentMappingsUpdatedItem = createSelector([selectDbaAgentDBNAgentMappings], (dbaAgentDBNAgentMappings) => dbaAgentDBNAgentMappings.update);

export const selectDbaAgentDBNAgentMappingsReadItem = createSelector([selectDbaAgentDBNAgentMappings], (dbaAgentDBNAgentMappings) => dbaAgentDBNAgentMappings.read);

export const selectDbaAgentDBNAgentMappingsDeletedItem = createSelector([selectDbaAgentDBNAgentMappings], (dbaAgentDBNAgentMappings) => dbaAgentDBNAgentMappings.delete);

export const selectDbaAgentDBNAgentMappingsSearchedItems = createSelector([selectDbaAgentDBNAgentMappings], (dbaAgentDBNAgentMappings) => dbaAgentDBNAgentMappings.search);

export const selectDbaAgentDBNAgentMappingsItemsCount = createSelector([selectDbaAgentDBNAgentMappings], (dbaAgentDBNAgentMappings) => dbaAgentDBNAgentMappings.count);

export const selectDbaAgentDBNAgentMappingsItemsFilter = createSelector([selectDbaAgentDBNAgentMappings], (dbaAgentDBNAgentMappings) => dbaAgentDBNAgentMappings.filter);